const FEATURE_HELP_URLS = {
  agent_bots: 'https://iungo.cloud/agent-bots',
  agents: 'https://iungo.cloud/agents',
  audit_logs: 'https://iungo.cloud/audit-logs',
  campaigns: 'https://iungo.cloud/campaigns',
  canned_responses: 'https://iungo.cloud/canned',
  channel_email: 'https://iungo.cloud/email',
  channel_facebook: 'https://iungo.cloud/fb',
  custom_attributes: 'https://iungo.cloud/custom-attributes',
  dashboard_apps: 'https://iungo.cloud/dashboard-apps',
  help_center: 'https://iungo.cloud/help-center',
  inboxes: 'https://iungo.cloud/inboxes',
  integrations: 'https://iungo.cloud/integrations',
  labels: 'https://iungo.cloud/labels',
  macros: 'https://iungo.cloud/macros',
  message_reply_to: 'https://iungo.cloud/reply-to',
  reports: 'https://iungo.cloud/reports',
  sla: 'https://iungo.cloud/sla',
  team_management: 'https://iungo.cloud/teams',
  webhook: 'https://iungo.cloud/webhooks',
  billing: 'https://iungo.cloud/pricing',
  saml: 'https://iungo.cloud/saml',
  captain_billing: 'https://iungo.cloud/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
